import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {StorageService} from '@services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})

export class SideBarService {
  isSidebarOpen: boolean = false;

  sidebarStateChange: Subject<boolean> = new Subject<boolean>();

  constructor(private storageService: StorageService) {
    this.sidebarStateChange.subscribe((value) => {
      this.isSidebarOpen = value;
    });
  }

  toggleSidebar(key: string) {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.storageService.writeValueToIndexedDb(key, this.isSidebarOpen);
    this.sidebarStateChange.next(this.isSidebarOpen);
  }

  hideSidebar() {
    this.isSidebarOpen = false;
    this.sidebarStateChange.next(false);
  }

  closeMobileDimmer(sidebarStatusKey: string, previousSidebarOpenState: boolean): void {
    if (sidebarStatusKey !== '') {
      this.storageService.readValueFromIndexedDb<string>(sidebarStatusKey).then(
          (value) => {
            if (!value) {
              return;
            }
            if (previousSidebarOpenState !== this.isSidebarOpen) {
              this.toggleSidebar(sidebarStatusKey);
            }

          },
          (error) => {
            console.log('Error', error);
          });
    }
  }

}
